import React from 'react';
import { Input, Button, Select, Viewer, Modal, Pagination, Tooltip, Table } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { 
	VerificationManualIcon,
	AlertIcon,
	CheckWhiteIcon,
	CloseIcon,
	ViewIcon,
	Menu as MenuIcons,
	ArrowRight2,
	CheckGreenCircle,
	CloseRedIcon,
	Calendar,
	PencilIcon,
	BankIcon,
	ListIcon,
	MoneyIcon,
	PhoneIcon,
	PlateIcon,
	DocumentIcon,
	User2Icon,
	GenderIcon,
	LicenseIcon,
	AgeIcon,
	SerialIcon,
	AddressIcon,
	CarIcon,
	ColorIcon,
	CategoryIcon,
	WeightIcon
} from 'assets/icons';
import moment from 'moment';
import { ReportService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class ViewVerification extends React.Component<Props> {

	state = {
		visible: false,
		file: null,
		session: null,
		intents: 0,
		documents: [],
		visible_verification: false,
		verification: null,
		selected_document: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Ver verificación',
				subtitle: 'Consulta y analiza todas los documentos registrados en el sistema.',
				color: '#f1f3fe',
				icon: MenuIcons.Menu5,
				onBack: () => {
					this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/documents');
				}
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		// @ts-ignore
		const token_id: number = this.props.match?.params?.id;

		if (!token_id) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/documents');
		}

		const res: any = await ReportService.admin.documents.view({
			token_id,
			withoutLoading,
			documents: this.state.documents?.map((i: any) => {
				return {
					document_type_id: i.document_type_id,
					page: i.page
				}
			})
		});
		if (!res.session || (res.session?.user_id !== this.props.user?.id && res.session?.user_id !== this.props.user?.user_id && (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR))) {
			this.props.history.replace(((this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) ? '/client' : '/admin') + '/documents');
			return;
		}
		this.setState({
			session: res.session,
			intents: res.intents || 0,
			documents: res.documents || [],
			// @ts-ignore
			verification: this.state.verification != null ? res.documents?.find((i: any) => i.document_type_id == this.state.verification?.document_type_id) : null,
			selected_document: this.state.selected_document == null ? (res.documents?.length > 0 ? res.documents[0].document_type_id : null) : this.state.selected_document
		});
	}

	view = (url: string) => {
		this.setState({
			visible: true,
			file: url
		});
	}

	setVisible = (value: boolean) => {
		this.setState({
			visible: value
		});
	}

	saveStatus = (verification: any) => {
		Globals.confirm(`¿Desea cambiar el estatus a verificado?`,async () => {
			await ReportService.admin.documents.saveStatus({
				verification_id: verification?.id,
				// @ts-ignore
				file: Globals.generateS3(verification?.file,true,verification?.s3_provider)
			});
			Globals.showSuccess("Se ha cambiado el estatus correctamente");
			this.load();
		});
	}

	onClose = () => {
		this.setState({
			visible_verification: false,
			verification: null
		});
	}

	viewVerification = (e: any, verification: any) => {
		e.preventDefault();
		this.setState({
			verification,
			visible_verification: true
		});
	}

	render() {
		const session: any = this.state.session;
		const { visible, documents, visible_verification } = this.state;
		const verification: any = this.state.verification;
		const _verification_index = documents?.findIndex((i: any) => i.document_type_id == verification?.document_type_id);

		const VerificationItem = ({ verification, verification_index } : {
			verification: any,
			verification_index: number
		}) => {
			return (
				<>
					<div className="container-gray">
						<div style={{ padding: '10px' }}>
							<div className="container-title">
								<h3>{ verification?.document_type?.name }</h3>
								<div style={{ marginLeft: '10px' }} className={ `container-result ${ !verification?.result ? 'red' : '' }` }>
									<div className={ `container-check ${ !verification?.result ? 'red' : '' }` }>
										<img src={ verification?.result ? CheckGreenCircle : CloseRedIcon } className="result-icon" />
									</div>
									{ verification?.result_text }
								</div>
							</div>
							<hr style={{ marginTop: '0px', marginBottom: '7px' }} />
							<div className="row">
								<div className="col-md-12 contain">
									<div className="row">
										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VOUCHER && (
												<>
													<div className="col-md-6">
														<div className="value-container">
															<img src={ BankIcon } />
															<div>
																<strong>Origen del documento</strong>
																<p className="value">{ verification?.bank_name || '-' }</p>
															</div>
														</div>
													</div>
													{
														verification?.destination_bank_name && (
															<div className="col-md-6">
																<div className="value-container">
																	<img src={ BankIcon } />
																	<div>
																		<strong>Destino del documento</strong>
																		<p className="value">{ verification?.destination_bank_name || '-' }</p>
																	</div>
																</div>
															</div>
														)
													}
													<div className="col-md-3">
														<div className="value-container">
															<img src={ ListIcon } />
															<div>
																<strong>Comprobante Nº</strong>
																<p className="value">{ verification?.reference || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha</strong>
																<p className="value">{ verification?.date ? moment(verification?.date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ MoneyIcon } />
															<div>
																<strong>Monto</strong>
																<p className="value">{ Globals.formatMiles(verification?.amount,true,'Bs.') }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ PhoneIcon } />
															<div>
																<strong>Teléfono</strong>
																<p className="value">{ verification?.phone || '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_VOUCHER && (
												<>
													<div className="col-md-6">
														<div className="value-container">
															<img src={ BankIcon } />
															<div>
																<strong>Origen del documento</strong>
																<p className="value">{ verification?.bank_name || '-' }</p>
															</div>
														</div>
													</div>
													{
														verification?.destination_bank_name && (
															<div className="col-md-6">
																<div className="value-container">
																	<img src={ BankIcon } />
																	<div>
																		<strong>Destino del documento</strong>
																		<p className="value">{ verification?.destination_bank_name || '-' }</p>
																	</div>
																</div>
															</div>
														)
													}
													<div className="col-md-3">
														<div className="value-container">
															<img src={ ListIcon } />
															<div>
																<strong>Comprobante Nº</strong>
																<p className="value">{ verification?.reference || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha</strong>
																<p className="value">{ verification?.date ? moment(verification?.date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ MoneyIcon } />
															<div>
																<strong>Monto</strong>
																<p className="value">{ Globals.formatMiles(verification?.amount,true,'$') }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.CASH && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ MoneyIcon } />
															<div>
																<strong>Monto</strong>
																<p className="value">{ Globals.formatMiles(verification?.amount,true,'$') }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ SerialIcon } />
															<div>
																<strong>Serial</strong>
																<p className="value">{ verification?.serial || '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.ID && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Nombres</strong>
																<p className="value">{ verification?.name || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Apellidos</strong>
																<p className="value">{ verification?.lastname || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Identificación</strong>
																<p className="value">{ verification?.document || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Nacimiento</strong>
																<p className="value">{ verification?.birthdate ? moment(verification?.birthdate).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.MEDICAL_CERTIFICATE && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Nombres</strong>
																<p className="value">{ verification?.name || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Apellidos</strong>
																<p className="value">{ verification?.lastname || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Identificación</strong>
																<p className="value">{ verification?.document || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ AgeIcon } />
															<div>
																<strong>Edad</strong>
																<p className="value">{ verification?.age || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expedición</strong>
																<p className="value">{ verification?.registration_date ? moment(verification?.registration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Documento</strong>
																<p className="value">{ verification?.number || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Grado</strong>
																<p className="value">{ verification?.grade || '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											(verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.RIF || verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_NIT) && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Nombres</strong>
																<p className="value">{ verification?.name || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Apellidos</strong>
																<p className="value">{ verification?.lastname || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Identificación</strong>
																<p className="value">{ verification?.document || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expedición</strong>
																<p className="value">{ verification?.registration_date ? moment(verification?.registration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-6">
														<div className="value-container">
															<img src={ AddressIcon } />
															<div>
																<strong>Dirección</strong>
																<p className="value">{ verification?.address || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ AddressIcon } />
															<div>
																<strong>Estado/Departamento</strong>
																<p className="value">{ verification?.state || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ AddressIcon } />
															<div>
																<strong>Ciudad</strong>
																<p className="value">{ verification?.city || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Actualización</strong>
																<p className="value">{ verification?.update_date ? moment(verification?.update_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.DRIVER_LICENSE && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Nombres</strong>
																<p className="value">{ verification?.name || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Apellidos</strong>
																<p className="value">{ verification?.lastname || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ GenderIcon } />
															<div>
																<strong>Género</strong>
																<p className="value">{ verification?.gender || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Tipo</strong>
																<p className="value">{ verification?.type || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Nacimiento</strong>
																<p className="value">{ verification?.birthdate ? moment(verification?.birthdate).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Identificación</strong>
																<p className="value">{ verification?.document || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expedición</strong>
																<p className="value">{ verification?.registration_date ? moment(verification?.registration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Nombres</strong>
																<p className="value">{ verification?.name || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ User2Icon } />
															<div>
																<strong>Apellidos</strong>
																<p className="value">{ verification?.lastname || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ LicenseIcon } />
															<div>
																<strong>Nº de Identificación</strong>
																<p className="value">{ verification?.document || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CarIcon } />
															<div>
																<strong>Marca</strong>
																<p className="value">{ verification?.brand || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CarIcon } />
															<div>
																<strong>Modelo</strong>
																<p className="value">{ verification?.model || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Año</strong>
																<p className="value">{ verification?.year || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ ColorIcon } />
															<div>
																<strong>Color</strong>
																<p className="value">{ verification?.color || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ WeightIcon } />
															<div>
																<strong>Capacidad de Carga</strong>
																<p className="value">{ verification?.weight || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ SerialIcon } />
															<div>
																<strong>Serial</strong>
																<p className="value">{ verification?.serial || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ PlateIcon } />
															<div>
																<strong>Placa</strong>
																<p className="value">{ verification?.plate || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CarIcon } />
															<div>
																<strong>Tipo de Vehículo</strong>
																<p className="value">{ verification?.vehicle_type || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CategoryIcon } />
															<div>
																<strong>Categoría</strong>
																<p className="value">{ verification?.category || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CarIcon } />
															<div>
																<strong>Puestos</strong>
																<p className="value">{ verification?.points || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ CarIcon } />
															<div>
																<strong>Ejes</strong>
																<p className="value">{ verification?.axles || '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.PLATE && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ PlateIcon } />
															<div>
																<strong>Placa</strong>
																<p className="value">{ verification?.plate || '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											(
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_PERMIT ||
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.RACDA ||
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.ROCT ||
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.RESQUIMC ||
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.INSOPESCA
											) && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ PlateIcon } />
															<div>
																<strong>Placa</strong>
																<p className="value">{ verification?.plate || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.RCV && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ PlateIcon } />
															<div>
																<strong>Placa</strong>
																<p className="value">{ verification?.plate || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ DocumentIcon } />
															<div>
																<strong>Tipo de Poliza</strong>
																<p className="value">{ verification?.policy_type_text || '-' }</p>
															</div>
														</div>
													</div>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										{
											(
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.FOOD_HANDLING ||
												verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.HEALTH_CERTIFICATE
											) && (
												<>
													<div className="col-md-3">
														<div className="value-container">
															<img src={ Calendar } />
															<div>
																<strong>Fecha de Expiración</strong>
																<p className="value">{ verification?.expiration_date ? moment(verification?.expiration_date).format('DD/MM/YYYY') : '-' }</p>
															</div>
														</div>
													</div>
												</>
											)
										}

										<div className="col-md-3">
											<div className="value-container">
												<img src={ PhoneIcon } />
												<div>
													<strong>Origen</strong>
													<p className="value">{ verification?.origin?.name || '-' }</p>
												</div>
											</div>											
										</div>
									</div>

									{
										!verification?.result && verification?.cases?.length > 0 && (
											<>
												<strong>Motivos</strong>
												<div className="container-tags">
													{
														verification?.cases?.map((item: any) => {
															return (
																<div className="tag">
																	<p>{ item.case?.name }</p>
																</div>
															)
														})
													}
												</div>
											</>
										)
									}

									{
										verification?.manual_verification_by != null && (
											<div className="alert-container" style={{ marginTop: '15px' }}>
												<img src={ AlertIcon } />
												<p>Cambio de estatus manual por { verification?.manual_verification_by?.name } { verification?.manual_verification_by?.lastname } - { moment(verification?.manual_verification_at).format('DD/MM/YYYY HH:mm') }</p>
											</div>
										)
									}

									<div className="row">
										<div className="col-md-8">
											<Pagination 
							      				inverse={ true }
												pages={ verification?.last_page } 
												active={ verification?.page }
												className="pagination-documents"
												onChange={ async (page: number) => {
													let documents: any = [...this.state.documents];
													documents[verification_index].page = page;
													await this.setState({
														documents
													});
													this.load();
												} } />
										</div>
										<div className="col-md-4">
											{
												(checkPermission(Constants.MODULES.DOCUMENTS,'write') || checkPermission(Constants.MODULES.ADMIN_DOCUMENTS,'write')) && !verification?.result && verification?.document_type_id == Constants.BRAVEALO_DOCUMENT_TYPES.RIF && (
													<button className="btn btn-verify" onClick={ () => this.saveStatus(verification) }>
														<img src={ PencilIcon } />
														Cambiar estado
													</button>	
												)
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="container-gray container-gray-image">
						<h3>Vista del documento</h3>
						<div className="container-image" onClick={ () => this.view(Globals.generateS3(verification?.file,true,verification?.s3_provider)) }>
							{
						        verification?.file?.toLowerCase().endsWith('.pdf') ? (
						            <iframe 
						                src={`https://docs.google.com/gview?url=${encodeURIComponent(Globals.generateS3(verification?.file, true, verification?.s3_provider))}&embedded=true`}
    									style={{ width: '100%', height: '400px', border: '1px solid #ccc' }}
						            />
						        ) : (
						            <img src={ Globals.generateS3(verification?.file,true,verification?.s3_provider) } />
						        )
						    }
						</div>
					</div>
				</>
			)
		}

		return (
			<div id="view-verification" className="documents">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setVisible(false) }
			      images={ [{ src: this.state.file }] }
			    />

			    <Modal
		          className="modal-view-verification"
		          visible={ visible_verification }
		          title=""
		          onClose={ () => this.onClose() }
		        >
		        	<div id="modal-view-verification">
			        	<VerificationItem
							verification_index={ _verification_index }
							verification={ verification }
						/>
					</div>
		      	</Modal>

		      	<div className="row" style={{ marginBottom: '15px' }}>
		      		<div className="col-md-6">
		      			<p className="id-usuario">ID Sesión: { session?.value || session?.identity_token?.value }</p>
		      			<p className="id-usuario">Intentos: { this.state.intents }</p>
		      		</div>
		      	</div>

				<div className="row">
					<div className="col-md-4">
						<div className="container-documents">
							<div style={{ display: 'flex', marginBottom: '10px' }}>
								<div className="container-icon">
									<img src={ MenuIcons.Menu5 } />
								</div>
								<div>
									<h4>Documentos del usuario ({ documents?.length })</h4>
									<p className="note">Seleccione un documento para ver los detalles</p>
								</div>
							</div>
							{
								documents.map((document: any, index: number) => {
									return (
										<a href="#" className={ `item-document ${ document?.document_type_id == this.state.selected_document ? 'active' : '' }` } onClick={ (e: any) => {
											e.preventDefault();
											this.setState({
												selected_document: document?.document_type_id
											});
										} }>
											<div>
												<div className="index">
													{ index + 1 }
												</div>
											</div>
											<div style={{ flex: 1 }}>
												<h3>{ document?.document_type?.name }</h3>
												<div className={ `container-result ${ !document?.result ? 'red' : '' }` } style={{ marginTop: '7px' }}>
													<div className={ `container-check ${ !document?.result ? 'red' : '' }` }>
														<img src={ document?.result ? CheckGreenCircle : CloseRedIcon } />
													</div>
													{ document?.result_text }
												</div>
												<p className="note">Intentos: { document?.last_page }</p>
											</div>
											<img src={ ArrowRight2 } className="arrow" />
										</a>
									)
								})
							}
						</div>
					</div>
					<div className="col-md-8">
						{
							documents.filter((i: any) => i.document_type_id == this.state.selected_document).map((verification: any) => {
								const _verification_index = documents.findIndex((i: any) => i.document_type_id == this.state.selected_document);

								return (
									<VerificationItem
										verification_index={ _verification_index }
										verification={ verification }
									/>
								)
							})
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ViewVerification);